// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
function Badge(Props) {
  var beaconOpt = Props.beacon;
  var text = Props.text;
  var positionOpt = Props.position;
  var sizeOpt = Props.size;
  var colorOpt = Props.color;
  var classNameOpt = Props.className;
  var dataTestId = Props.dataTestId;
  var beacon = beaconOpt !== undefined ? beaconOpt : false;
  var position = positionOpt !== undefined ? positionOpt : "absolute";
  var size = sizeOpt !== undefined ? sizeOpt : /* Normal */1;
  var color = colorOpt !== undefined ? colorOpt : /* Accent */0;
  var className = classNameOpt !== undefined ? classNameOpt : CSS$Showside.prefix("top-0 right-0");
  if (text !== undefined) {
    var tmp;
    switch (color) {
      case /* Accent */0:
        tmp = "bg-accent";
        break;
      case /* InvertAccent */1:
        tmp = "bg-main";
        break;
      case /* Red */2:
        tmp = "bg-red-500";
        break;
    }
    var tmp$1;
    switch (color) {
      case /* Accent */0:
        tmp$1 = "text-main";
        break;
      case /* InvertAccent */1:
        tmp$1 = "text-accent";
        break;
      case /* Red */2:
        tmp$1 = "text-white";
        break;
    }
    var tmp$2 = {
      children: React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make(["relative flex items-center justify-center font-bold text-sm px-1", tmp$1])),
        style: {
          minWidth: size ? "18px" : "14px"
        }
      }, text)
    };
    if (dataTestId !== undefined) {
      tmp$2.dataTestId = Caml_option.valFromOption(dataTestId);
    }
    return React.createElement("div", {
      className: Cn.make([CSS$Showside.prefix(Cn.make([position === "relative" ? "relative" : "absolute -translate-y-1/2 translate-x-1/2 transform origin-right", position === "relative" ? "" : size ? "mt-2 mr-2" : "mt-1 mr-1"])), className])
    }, React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["absolute rounded-full w-full h-0 aspect-ratio-square top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2", tmp]))
    }), React.createElement(DataAttribute$Showside.make, tmp$2));
  }
  if (!beacon) {
    return null;
  }
  var tmp$3;
  switch (color) {
    case /* Accent */0:
      tmp$3 = "bg-accent";
      break;
    case /* InvertAccent */1:
      tmp$3 = "bg-main";
      break;
    case /* Red */2:
      tmp$3 = "bg-red-500";
      break;
  }
  var tmp$4;
  switch (color) {
    case /* Accent */0:
      tmp$4 = "bg-accent";
      break;
    case /* InvertAccent */1:
      tmp$4 = "bg-main";
      break;
    case /* Red */2:
      tmp$4 = "bg-red-500";
      break;
  }
  return React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["w-3 h-3 rounded-full flex items-center justify-center", tmp$3]))
  }, React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["rounded-full w-3 h-3", "animate-beacon", tmp$4]))
  }));
}
Badge.displayName = "Badge";
var make = Badge;
export { make };
/* react Not a pure module */